import Service from "./BaseService";

const getPolicyInfo = (step) => Service.get('/odoo/policy-info')

const PolicyInfoService = {
  getPolicyInfo,
};

export default PolicyInfoService;